<template>
  <div class="wrapper" id="wrapper">
    <div class="privacy-content" id="text-content">
      <div id="main">
        <div id="content">
          <span>版本{{ version }}</span>
        </div>
        <div class="arrow" id="selectImg"></div>
        <div id="selectItem"></div>
      </div>
      <div class="line"></div>

      <KyAgreement />
    </div>
    <p id="download" class="downloadText">点击下载此政策</p>
  </div>
</template>
<script setup>
import KyAgreement from '../ky-agreement'
const versionMap = {
  KyPrivacyPolicy_01: '0.1',
  KyPrivacyPolicy_1_0: '1.0',
  KyPrivacyPolicy: '2.0',
}
definePageMeta({
  layout: 'clear',
})
useHead({
  title: '隐私权保护政策',
})
if (process.client) {
  import('@/components/protocol/privacy.js')
}
const version = ref('2.0')
const route = useRoute()

let { luban8Cid } = route.query
if (luban8Cid) {
  version.value = versionMap[luban8Cid]
  console.log('=version==', version)
}
</script>

<style lang="less">
.title {
  font-family: PingFangSC-Medium;
  font-size: 0.36rem;
  text-align: center;
  line-height: 2.5;
}
.sub-title {
  font-family: PingFangSC-Medium;
  font-size: 0.3rem;
  line-height: 2;
}
.text {
  font-family: PingFangSC-Regular;
  font-size: 0.26rem;
  text-align: justify;
  line-height: 1.5;
}

.important {
  font-weight: bold;
  text-decoration: underline;
}
.bold {
  font-weight: bold;
}
.underline {
  text-decoration: underline;
}
.little-title {
  font-family: PingFangSC-Regular;
  margin: 0.08rem 0;
}
.paragraph {
  font-family: PingFangSC-Regular;
  margin: 0.15rem 0;
  text-align: justify;
}
.indent {
  text-indent: 2em;
}
.indent3 {
  text-indent: 3em;
}
.ol-decimal {
  list-style-type: decimal;
  list-style-position: outside;
}

.ol-disc {
  list-style-type: disc;
  list-style-position: outside;
}

.list {
  margin-left: 0.45rem;
}
.menu {
  .content {
    margin-left: 0.25rem;
  }
}
.select {
  font-family: PingFangSC-Medium;
  font-size: 0.3rem;
  position: absolute;
  right: 0;
  background-color: transparent;
}
.downloadText {
  font-family: PingFangSC-Medium;
  font-size: 0.26rem;
  text-align: center;
  line-height: 2.5;
  color: blue;
}
#main {
  width: 60px;
  height: 22px;
  position: absolute;
  right: 10px;
  top: 20px;
  z-index: 10;
}
#content {
  width: 60px;
  height: 22px;
  line-height: 22px;
  padding-left: 6px;
  background: rgb(255, 255, 255);
  border-radius: 2px;
  // border: 1px solid rgb(221, 221, 221);
  font-size: 11px;
  font-family: MicrosoftYaHei;
  color: rgb(51, 51, 51);
  cursor: pointer;
}
#selectImg {
  position: absolute;
  top: 13px;
  cursor: pointer;
}
#selectItem {
  display: none;
  border: 1px solid #eee;
  width: 60px;
}
#selectItem ul {
  list-style: none;
}
#selectItem ul li {
  height: 20px;
  font-size: 11px;
  line-height: 20px;
  padding-left: 10px;
  cursor: pointer;
}
#selectItem ul li:hover {
  background-color: #f5f7fa;
}
.arrow {
  width: 0;
  height: 0;
  border: 6px solid #333;
  border-color: #333 transparent transparent transparent;
  position: absolute;
  right: 0;
  margin-top: -4px;
}
</style>
